import React from "react";
import { X, Check } from "lucide-react";
import FriendlyFlag from "./FriendlyFlag";

// One applicant row in the owner's applications list (design Frame 4 / Frame 8).
// Shows crest + name + country + league tier + optional note. Distance is
// intentionally absent (D-005). EXACTLY two actions on a pending application —
// "Start chat" (primary → opens the EXISTING club↔club chat) and a quiet dismiss
// (the card just leaves; nothing is ever sent). Marking a camp match as agreed
// happens IN THE CHAT (canvas: "mark applications as agreed from their chat"), via
// the friendly_request unfurl's owner CTA — never a third button here (M3-review
// F-M3-3). An already-agreed row shows a calm agreed BADGE only.
const initials = (name = "") =>
  name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";

const ApplicationRow = ({ application, onStartChat, onDismiss, busy }) => {
  const club = application.applicant_club || {};
  const agreed = application.status === "agreed";
  const inChat = application.status === "in_chat";
  const cid = application.channel_cid;

  return (
    <div className="flex items-start gap-3 py-3 border-t border-[#F2F5F9]" data-testid="friendly-application-row">
      {club.crest ? (
        <img src={club.crest} alt="" className="w-8 h-8 rounded-full object-cover flex-shrink-0" referrerPolicy="no-referrer" />
      ) : (
        <span className="w-8 h-8 rounded-full bg-[#0B3E8F] text-white text-[11px] font-bold flex items-center justify-center flex-shrink-0">{initials(club.name)}</span>
      )}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 min-w-0">
          <span className="text-[13.5px] font-semibold text-[#0F1728] truncate">{club.name}</span>
          <FriendlyFlag country={application.country} width={16} height={12} />
          {application.country?.name && <span className="text-[11.5px] text-[#98A2B3] truncate">{application.country.name}</span>}
          {application.tier != null && <span className="text-[11.5px] text-[#66707F]">· Tier {application.tier}</span>}
        </div>
        {application.note && <p className="mt-0.5 text-[12.5px] italic text-[#475467] leading-snug">"{application.note}"</p>}
      </div>

      <div className="flex items-center gap-1.5 flex-shrink-0">
        {agreed ? (
          <>
            <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11.5px] font-semibold" style={{ backgroundColor: "#E7F6EF", color: "#0E7B52" }}>
              <Check className="w-3.5 h-3.5" /> Agreed
            </span>
            {cid && (
              <button onClick={() => onStartChat && onStartChat(application)} className="px-3 py-1.5 rounded-lg border border-[#2283FF] text-[#1866CC] text-[12px] font-semibold hover:bg-[#F0F7FF]">Open chat</button>
            )}
          </>
        ) : inChat ? (
          <button onClick={() => onStartChat && onStartChat(application)} disabled={!cid} className="px-3 py-1.5 rounded-lg border border-[#2283FF] text-[#1866CC] text-[12px] font-semibold hover:bg-[#F0F7FF] disabled:opacity-50">
            {cid ? "Open chat" : "In chat"}
          </button>
        ) : (
          <>
            <button onClick={() => onStartChat && onStartChat(application)} disabled={busy} className="px-3 py-1.5 rounded-lg bg-[#2283FF] text-white text-[12px] font-semibold hover:bg-[#186FE0] disabled:opacity-50" data-testid="app-start-chat">Start chat</button>
            <button onClick={() => onDismiss && onDismiss(application)} disabled={busy} className="w-7 h-7 flex items-center justify-center rounded-lg text-[#98A2B3] hover:bg-gray-100 hover:text-[#475467]" aria-label="Dismiss application" title="Dismiss" data-testid="app-dismiss">
              <X className="w-4 h-4" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ApplicationRow;
